import io from 'socket.io-client';

class SocketV2Client {
  constructor(namespace = '/v2') {
    this.namespace = namespace;
    this.socket = null;
  }

  connect(url, token) {
    this.socket = io(url + this.namespace, {
      auth: { token },
      transports: ['websocket'],
      // Étale les reconnexions spontanées au lieu du défaut ~1-2s (voir
      // incident 500 du 2026-08-20). Le délai après un arrêt planifié du
      // serveur est piloté par l'évènement 'server:shutdown'.
      reconnectionDelay: 2000,
      reconnectionDelayMax: 20000,
      randomizationFactor: 0.5,
    });
    this.socket.on('connect_error', (error) => {
      console.error('[SocketV2] connection error:', error.message);
    });
    this.socket.on('disconnect', (reason) => {
      console.warn('[SocketV2] disconnected:', reason);
    });
    this.socket.on('server:shutdown', ({ retryAfter }) => {
      this.socket.io.reconnectionDelay(retryAfter);
      this.socket.io.reconnectionDelayMax(retryAfter);
    });
    return this;
  }

  on(collection, handler) {
    if (this.socket) {
      this.socket.on(collection, handler);
    }
  }

  off(collection, handler) {
    if (this.socket) {
      this.socket.off(collection, handler);
    }
  }

  reconnect(token) {
    if (this.socket) {
      this.socket.auth = { token };
      this.socket.connect();
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export default SocketV2Client;
